import { module } from 'modujs';
import isEmail from "is-email";
import Emitter from "tiny-emitter/instance";

export default class extends module {
    constructor( m ) {
        super( m );
        this.events = { click : { 'scroll-to' : 'scroll', } };
        this.inputs = this.el.querySelectorAll( 'input[type="text"]:not(.skip-validation),input[type="tel"]:not(.skip-validation),textarea' );
        this.checkboxes = this.el.querySelectorAll( 'input[type="checkbox"],textarea,input[type="file"]' );
        this.select = this.el.querySelectorAll( '[data-module-my-custom-select]' );
        this.message = this.$( 'message' )[0];

        this.submitBtn = this.$( 'submit' )[0];
        this.validationFields = [ ... this.el.querySelectorAll( '[data-validate]')];


        this.submitBtn.addEventListener( 'click', (e) => {
           if( ! this.validateForm() ){
               e.preventDefault();
           } else {
               this.el.classList.add( 'pointer-events-none' );
               this.submitBtn.classList.add( 'loading' );
           }
        });

        document.addEventListener( 'wpcf7mailsent', (e) => {

            if( this.$( 'turnstile' )[0] ){
                turnstile.reset( this.$( 'turnstile' )[0] );
            }

            [ ...this.inputs ].forEach( input => {
                input.parentNode.classList.remove( 'is-focused' );
            } );
            Emitter.emit( 'reset-custom-select', false);
            this.scrollToMessage( 7000 );


        });

        document.addEventListener( 'wpcf7mailfailed', (e) => {
            if( this.$( 'turnstile' )[0] ){
                turnstile.reset( this.$( 'turnstile' )[0] );
            }
            this.scrollToMessage();
        });


        document.addEventListener( 'wpcf7invalid', (e) => {
            if( this.$( 'turnstile' )[0] ){
                turnstile.reset( this.$( 'turnstile' )[0] );
            }
            this.scrollToMessage();
        });


        [ ...this.inputs ].forEach( input => {
            input.addEventListener( 'focus', e => {
                e.target.parentNode.classList.add( 'is-focused' );
            } );
            input.addEventListener( 'blur', e => {
                if( e.target.value === '' ){
                    e.target.parentNode.classList.remove( 'is-focused' );
                }
                this.validateField( e.target );
            } );
            input.addEventListener( 'input', e => {
                if( e.target.dataset.invalid === 'true' ){
                    this.validateField( e.target );
                }
            });

        } );
        [ ...this.checkboxes ].forEach( input => {
            input.addEventListener( 'change', e => {
                this.validateField( e.target );
                if( e.currentTarget.dataset.invalid === 'true' ){

                }
            });
        });


        [ ...this.select ].forEach( input => {
            input.addEventListener( 'click', e => {
                if( e.currentTarget.querySelector('select').dataset.invalid === 'true' ){
                    this.validateField( e.target );
                }
            });
        });




        if( this.$( 'turnstile' )[0] ){
            turnstile.render( this.$( 'turnstile' )[0] , { sitekey: '0x4AAAAAAAIbTBY67V5Xgbxu' });
        }


    }


    scrollToMessage( delay = 3000) {
        this.el.classList.remove( 'pointer-events-none' );
        this.submitBtn.classList.remove( 'loading' );
        if ( this.message ){
            this.call( 'scrollTo', { target : this.message, options: { offset : -window.innerHeight / 2 + this.message.getBoundingClientRect().height } }, 'Scroll' );
        }
        setTimeout( () => {
            this.el.classList.remove( 'sent' );
            this.el.classList.remove( 'failed' );
        }, delay );
    }




    validateField( field ){
        let hasError = false;
        let validate = field.dataset.validate;
        this.errorClassElements = [ ...field.closest( '[data-form="field"]' ).querySelectorAll( '[data-error-class]' ) ];
        if( field.closest( '[data-validate-group]' ) && field.closest( '[data-validate-group]' ).dataset.validateGroup === "false" ){
            // do nothing
        }
        else if( validate === 'required' || validate === 'tel' || validate === 'textarea' ){
            hasError = field.value === '';
        } else if( validate === 'email' ){
            hasError = ! isEmail( field.value );
        } else if( validate === 'email-or-empty' ){
            hasError = field.value !== '' && ! isEmail( field.value );
        } else if( validate === 'checkbox' ){
            hasError = ! field.checked;
        } else if(validate === 'required-select'){
            hasError = field.querySelector( 'option[value=""]').selected
        } else if( validate === 'radio' ){
            hasError = field.querySelector( 'input:checked') ? false : true;
        }


        this.errorClassElements.forEach( el => {
            let classNames = el.dataset.errorClass.split( ' ' );
            classNames.forEach( className => {
               el.classList.toggle( className, hasError );
            });
        });

        field.dataset.invalid = hasError ? 'true' : 'false';

        this.call( 'update', false, 'Scroll' );

        return ! hasError;
    }

    validateForm(){
        let formHasError = false;
        let scrollTo = false;
        this.validationFields.forEach( field => {
            if( ! this.validateField( field ) ){
                formHasError = true;
                if( !scrollTo){
                    scrollTo = field;
                }
            }
        });

        if( formHasError ){
            this.call('scrollTo', { target : scrollTo, options: { offset: -150 } },  'Scroll');
        }
        return ! formHasError;
    }



}
